/**
 * Builds a count label that agrees in number and groups thousands, e.g.
 * `1 Testimonial` vs `8 Testimonials` vs `1,184 Reviews`. The locale is pinned
 * so the server and client render the same string during hydration.
 */
export function formatCountLabel(count: number, singular: string, plural: string = `${singular}s`): string {
  return `${count.toLocaleString('en-US')} ${Math.abs(count) === 1 ? singular : plural}`;
}
